import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LoadingPopupComponent } from 'src/app/components/ui/loading-popup/loading-popup.component';
import { ModalSchedulerTaskComponent } from 'src/app/components/ui/modal-scheduler-task/modal-scheduler-task.component';
import { DeviceService } from 'src/app/services/devices/device.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-charge-scheduler',
    templateUrl: './charge-scheduler.component.html',
    styleUrls: ['./charge-scheduler.component.scss'],
    standalone: false
})
export class ChargeSchedulerComponent implements OnInit {

  device: string;
  tasks: any = { timeTasks: {}, powerTasks: { weekday: [], weekend: [] }};
  originalTasks: any = {};
  powerTasks: any = { weekday: [], weekend: [] };

  modalAdd: NgbModalRef;
  newTaskId: number;

  @Input()
  allSettings = false;

  @Input()
  connectors: any;

  modalLoad: NgbModalRef;

  successMessage = {};
  error = {};

  // Modal de advertencia
  showWarningModal = false;
  warningMessage = '';
  pendingTask: any = null;
  pendingConnectorName = '';
  pendingAction: 'add' | 'edit' = 'add';


  days: { [key: string]: boolean } = {
  monday: true,
  tuesday: true,
  wednesday: true,
  thursday: true,
  friday: true,
  saturday: true,
  sunday: true
};

daysOfWeek = [
  { label: 'L', value: 'monday' },
  { label: 'M', value: 'tuesday' },
  { label: 'X', value: 'wednesday' },
  { label: 'J', value: 'thursday' },
  { label: 'V', value: 'friday' },
  { label: 'S', value: 'saturday' },
  { label: 'D', value: 'sunday' }
];

weekday: number;

  constructor(
    public _dService: DeviceService,
    private _aRoute: ActivatedRoute,
    private _modal: ModalService,
    public _utils: UtilsService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.powerTasks = { weekday: [], weekend: [] };

    this._aRoute.parent?.parent?.params
      .subscribe((params: Params) => this.device = params['serial']);

      setTimeout(() => {
        this.connectors.forEach(conn => {
          this._dService.getElementModule(this.device, 'schedman', conn.name)
            .subscribe(data => {
              let t = JSON.parse(data.cfg.tasks);
              console.log(this.tasks);

              t = t.filter(task=>task.type==0);
              t = t.sort((t1, t2)=>t1.initTime.timeList[0].hourMin-t2.initTime.timeList[0].hourMin);
              this.tasks['timeTasks'][conn.name] = t;

              t = JSON.parse(data.cfg.tasks);
              t = t.filter(task=>task.type==1);
              t = t.sort((t1, t2)=>t1.initTime.timeList[0].hourMin-t2.initTime.timeList[0].hourMin);

              this.tasks['powerTasks'][conn.name]={};
              this.tasks['powerTasks'][conn.name]['weekday'] = t.filter(ta=>ta.initTime.weekday==62)||[];
              this.powerTasks['weekday']=this.powerTasks['weekday'].concat(t.filter(ta=>ta.initTime.weekday==62));
              this.tasks['powerTasks'][conn.name]['weekend'] = t.filter(ta=>ta.initTime.weekday==65)||[];
              this.powerTasks['weekend']=this.powerTasks['weekend'].concat(this.tasks['powerTasks'][conn.name]['weekend']);

              this.newTaskId=this.getFreeIdFromTasks();

              console.log(this.tasks)

              this.successMessage[conn.name]=false;
              this.error[conn.name]='';
            })
        });
      }, 500);

  }

  openAddTask(cName){
    this.modalAdd=this._modal.open(ModalSchedulerTaskComponent);
    this.modalAdd.componentInstance.id=this.newTaskId;
    this.modalAdd.componentInstance.type=0;
    this.modalAdd.componentInstance.weekday=0;

    this.modalAdd.result.then((task) => {
      // Comprueba si hay tareas que se solapan
      if (this.hasTimeOverlap(task, this.tasks['timeTasks'][cName], cName)) {
        this.showOverlapWarning(task, cName, 'add');
        return;
      }

      this.tasks['timeTasks'][cName].push(task);
      console.log(this.tasks['timeTasks']);
      this.newTaskId=this.getFreeIdFromTasks();
      this.error[cName] = ''; // limpiar errores previos
    }, (reason) => {
      // on dismiss
    });
  }

  getFreeIdFromTasks(){
    let idTaskDisp = 1;
    let found = false;

    let ids: any[] = [];

    this.powerTasks['weekday'].forEach(t => {
      ids.push(t.id);
    });

    this.powerTasks['weekend'].forEach(t => {
      ids.push(t.id);
    });

    this.connectors.forEach(element => {
      if(this.tasks['timeTasks'][element.name])
        this.tasks['timeTasks'][element.name].forEach(t => {
          ids.push(t.id);
        });
    });


    console.log(ids);

    while(!found){
      if(ids.includes(idTaskDisp)) idTaskDisp++;
      else found=true;
    }


    console.log("NEW ID: " + idTaskDisp);
    return idTaskDisp;
  }

  save(element){
    let t = this.tasks['timeTasks'][element];
    this.modalLoad = this._modal.open(LoadingPopupComponent);
    t.forEach(t => {
      if (t.initTime.weekday == 127)t.initTime.weekday = 0;
    });
    console.log('tarea a guardar ', t);

    this.saveConfig(element, t);
  }

  saveConfig(element, tasks){
    this._dService.setModuleElement(this.device, 'schedman', { tasks }, element)
        .subscribe(data=>{
          this.successMessage[element] = true;
          this.modalLoad .close();
          setTimeout(() => {
            this.successMessage[element] = false;
          }, 10000);
        }, err => {
          console.error(err)
          this.error[element] = err.error.message;
          this.modalLoad .close();
          setTimeout(() => {
            this.error[element] = '';
          }, 10000);
        })
  }

  deleteTask(id, element){
    var data = {
      tasks: [{id, type:0}]
    }

    this._dService.deleteModuleElement(this.device, 'schedman', data, element)
      .subscribe(data=>{
        this.successMessage[element] = true;
        this.tasks['timeTasks'][element]=this.tasks['timeTasks'][element].filter(t=>t.id!=id);

        setTimeout(() => {
          this.successMessage[element] = false;
        }, 10000);
      }, err => {
        console.error(err)
        this.error[element] = err.error.message;
        setTimeout(() => {
          this.error[element] = '';
        }, 10000);
      })
  }

  openEditTask(task){
    let t = {...task};
    this.modalAdd=this._modal.open(ModalSchedulerTaskComponent);
    this.modalAdd.componentInstance.type=0;
    this.modalAdd.componentInstance.task={...task};
    this.modalAdd.componentInstance.weekday=task.initTime.weekday;

    this.modalAdd.result.then((editedTask) => {
      // Find the connector name for this task
      let connectorName = '';
      for (let connName of Object.keys(this.tasks['timeTasks'])) {
        if (this.tasks['timeTasks'][connName].find(t => t.id === editedTask.id)) {
          connectorName = connName;
          break;
        }
      }

      // Check for overlapping tasks (excluding the current task being edited)
      if (this.hasTimeOverlap(editedTask, this.tasks['timeTasks'][connectorName], connectorName)) {
        this.showOverlapWarning(editedTask, connectorName, 'edit');
        return;
      }

      // Update the task in the array
      const taskIndex = this.tasks['timeTasks'][connectorName].findIndex(t => t.id === editedTask.id);
      if (taskIndex !== -1) {
        this.tasks['timeTasks'][connectorName][taskIndex] = editedTask;
        this.error[connectorName] = ''; // Clear any previous errors
      }

      console.log('Task updated:', editedTask);
    }, (reason) => {
      // Restore original task if editing was cancelled
      // No changes needed since we're not modifying the original array until confirmed
    });
  }


  // Check if a new task overlaps with existing tasks
  hasTimeOverlap(newTask: any, existingTasks: any[], connectorName: string): boolean {
    if (!existingTasks || existingTasks.length === 0) {
      return false;
    }

    const newStart = newTask.initTime.timeList[0].hourMin;
    const newEnd = newStart + newTask.initTime.timeList[0].duration;
    const newDays =   this._utils.setDaysFromBitmask(newTask.initTime.weekday);

    for (let existingTask of existingTasks) {
      if (existingTask.id === newTask.id) {
        continue;
      }

      const existingStart = existingTask.initTime.timeList[0].hourMin;
      const existingEnd = existingStart + existingTask.initTime.timeList[0].duration;
      const existingDays =  this._utils.setDaysFromBitmask(existingTask.initTime.weekday)

      // Check if they share any common days
      const hasCommonDays = Object.keys(newDays).some(day =>
        newDays[day] && existingDays[day]
      );

      if (hasCommonDays) {
        // Check time overlap
        if (this.timeRangesOverlap(newStart, newEnd, existingStart, existingEnd)) {
          return true;
        }
      }
    }

    return false;
  }

  // Helper function to check if two time ranges overlap
  timeRangesOverlap(start1: number, end1: number, start2: number, end2: number): boolean {
    return start1 < end2 && start2 < end1;
  }

  // Mostrar modal de advertencia de solapamiento
  showOverlapWarning(task: any, connectorName: string, action: 'add' | 'edit') {
    this.pendingTask = task;
    this.pendingConnectorName = connectorName;
    this.pendingAction = action;
    this.warningMessage = action === 'add'
      ? this.translate.instant('NewTaskOverlapping')
      : this.translate.instant('EditTaskOverlapping') ;
    this.showWarningModal = true;
  }

  // Confirmar y proceder con la tarea a pesar del solapamiento
  confirmOverlap() {
    if (this.pendingTask && this.pendingConnectorName) {
      if (this.pendingAction === 'edit') {
        // Es una edición - buscar y actualizar la tarea existente
        const taskIndex = this.tasks['timeTasks'][this.pendingConnectorName].findIndex(t => t.id === this.pendingTask.id);
        if (taskIndex !== -1) {
          this.tasks['timeTasks'][this.pendingConnectorName][taskIndex] = this.pendingTask;
        }
      } else {
        // Es una nueva tarea - agregar al array
        this.tasks['timeTasks'][this.pendingConnectorName].push(this.pendingTask);
        this.newTaskId = this.getFreeIdFromTasks();

      }
      this.error[this.pendingConnectorName] = ''; // Borrar errores previos
    }
    this.closeWarningModal();
  }

  // Cancelar y cerrar el modal de advertencia
  cancelOverlap() {
    this.closeWarningModal();
  }

  // Cerrar el modal de advertencia
  closeWarningModal() {
    this.showWarningModal = false;
    this.warningMessage = '';
    this.pendingTask = null;
    this.pendingConnectorName = '';
    this.pendingAction = 'add';
  }

  // Método para obtener el rango de tiempo formateado, manejando duraciones que exceden 24 horas
  getTimeRange(task: any): string {
    if (!task?.initTime?.timeList?.[0]) {
      return '';
    }

    const startMin = task.initTime.timeList[0].hourMin;
    const duration = task.initTime.timeList[0].duration;
    const endMin = startMin + duration;

    // Calcular horas y minutos para inicio y fin, considerando días
    const startTime = this._utils.getDateFromMinutes(startMin % 1440);
    const endTime = this._utils.getDateFromMinutes(endMin % 1440);

    // Calcular cuántos días cruza
    const daysCrossed = Math.floor(endMin / 1440) - Math.floor(startMin / 1440);

    if (daysCrossed > 0) {
      return `${startTime} - ${endTime} (+${daysCrossed} día${daysCrossed > 1 ? 's' : ''})`;
    } else {
      return `${startTime} - ${endTime}`;
    }
  }

}
